export default __webpack_public_path__ + "static/media/3100.f8f4b9d9.jpg";